module.exports = __webpack_public_path__ + "static/banner-casino-8a76c4bf18cac5f839c554d7f5bd3859.jpg";